export enum Language {
  FR = "fr",
  EN = "en",
}
